// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__5F48p","image":"Loader_image__MC4vj"};